import { type CohortBuilderDefinitionLegacy } from '@verantos-dev/types-cohorts';

import { validateForDuplicateNames } from './cohort-definition-validation/validateForDuplicateNames';

/**
 * This function will validate the current cohort definition and determine whether it is valid for save.
 *
 * @param {CohortBuilderDefinition} cohortDefinition - the current cohort builder definition to validate
 * @returns {boolean} - true if the cohort definition is valid for save, false otherwise
 */
export const validateCohortDefinitionForSave = ({
  studyPeriodRestrictions,
  subjectVariables,
  derivedEvents,
  simpleEvents,
  indexDate,
}: CohortBuilderDefinitionLegacy): boolean => {
  /** Verify no duplicate names exist */
  const { hasDuplicateName } = validateForDuplicateNames(
    subjectVariables,
    derivedEvents,
    simpleEvents
  );

  /** Verify at least one cohort builder item is defined */
  const hasCohortBuilderItems =
    studyPeriodRestrictions?.baselinePeriodRestriction?.isEnabled ||
    studyPeriodRestrictions?.followUpPeriodRestriction?.isEnabled ||
    studyPeriodRestrictions?.overallStudyPeriodRestriction?.isEnabled ||
    subjectVariables.length > 0 ||
    derivedEvents.length > 0 ||
    simpleEvents.length > 0 ||
    indexDate !== undefined;

  // Return true if all validations pass, if any validation is true, then we can consider this cohort definition invalid and return false
  return !hasDuplicateName && hasCohortBuilderItems;
};
